(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["full-section-image-slider"] && !Shopify.designMode) return;
  try {
    

  $(function() {
    
    const fullSectionImageSlider = $('.full-section-image-slider');
    
    fullSectionImageSlider.owlCarousel({
        loop:true,
        nav:false,
        autoplay:true,
        autoplaySpeed: 800,
        autoplayTimeout:6000,
        autoplayHoverPause:false,
        dots: false,
        responsive:{
            0:{
                items:1
            },
            600:{
                items:1
            },
            1000:{
                items:1
            }
        }
    });

    $(".full-section-image-slider_nav-arrow.next").click(function () {
      fullSectionImageSlider.trigger('next.owl.carousel');
    });

    $(".full-section-image-slider_nav-arrow.prev").click(function () {
      fullSectionImageSlider.trigger('prev.owl.carousel');
    });
    
  })
  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    

  //Mega menu on hover
  $(".header__inline-menu__list-item").mouseover(function() {
    $(".mega-menu").removeAttr("open");
    $(this).find(".mega-menu").attr("open", "true");
  });
  
  $(".mega-menu__content").mouseleave(function() {
    $(this).parent().removeAttr("open");
  });

  //Mega menu second level hover effect
  $('.header-nav-list-item__second-level:first-child').addClass('active')
  $('.header-nav-list-item__second-level').on('mouseover', function() {
    $('.header-nav-list-item__second-level').removeClass('active')
    $(this).addClass('active');
  })

  
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.getElementById('shopify-section-header');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  $('.header-hamburger-menu').on('click', function () {
    console.log('Clicked');
    $(this).children('.header-hamburger-menu-wrapper').toggleClass("active");
    $('.mega-menu-wrapper').toggleClass("open");
  });      

  // $('#headerInlineMenu').find('ul .header__inline-menu__list-item').on('click', function() {
  //   $('.header-nav-list').children().first().toggleClass("active");    
  // });

  // $('.header-nav-list > :first-child').hover(
    
  //   function($) {
  //     console.log('hover');
  //     $(this).siblings(".header-nav-list-item").removeClass("active");
  //   }
   
  // );
  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-banner-slider"] && !Shopify.designMode) return;
  try {
    

  $(function() {
    
    const imageBannerSlider = $('.image-banner-slider');
    
    imageBannerSlider.owlCarousel({
        loop:true,
        nav:false,
        autoplay:true,
        autoplaySpeed: 800,
        autoplayTimeout:6000,
        autoplayHoverPause:false,
        dots: false,
        responsive:{
            0:{
                items:1
            },
            600:{
                items:1
            },
            1000:{
                items:1
            }
        }
    })
  })
  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["list-collection-section"] && !Shopify.designMode) return;
  try {
    
  $(document).ready(function(){
    
    $("#backBtn").on('click', function(e){
      console.log('Back');
      e.preventDefault();
      window.history.back();
    });
 
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-product-grid"]) return;
  try {
    
  $(document).ready(function(){
    
    $("#backBtn").on('click', function(e){
      console.log('Back');
      e.preventDefault();
      window.history.back();
    });

    // Filter Dropdowns  
    $('.tier-2 .t2-active').parent().parent().parent().toggleClass("active");
    $('.tier-2 .t2-active').parent().parent().parent().find(".t1-link").toggleClass("t1-active");

    if($(window).width() > 750) {
      $('.tier-2 .t2-active').parent().parent().slideToggle();
      $('.tier-2 .t2-active').parent().parent().parent().find(".t1-link > span").toggleClass("active");
    }
    
    $("#collectionFilters ul .collection-filter-item a span").click(function(e){
        e.preventDefault();
        $(this).parent().next().slideToggle();
        $(this).toggleClass("active");
    });
       
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    

  $('#enquireButton').click(function() {
    console.log('Click');
    $('#enquireFormModal').css("display","block");
  });

  $('#enquireFormModal .modal-content .close').click(function() {
    console.log('Click');
    $('#enquireFormModal').css("display","none");
  });

  // $(document).ready(function() {
  //   $('.product__description *').removeAttr('style'); 
  //   $('.product__description *').removeAttr('data-mce-style');
  // });



  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["news-carousel"] && !Shopify.designMode) return;
  try {
    

  $(function() {
    
    const newsCarousel = $('.news-carousel');
    
    newsCarousel.owlCarousel({
      margin: 20,
      loop: false,
      nav: false,
      autoplay: false,
      dots: true,
      responsive:{
          0:{
              items: 1
          },
          600:{
              items: 3
          },
          1000:{
              items: 3
          }
      }
    });
  
  })
  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["our-people-section"] && !Shopify.designMode) return;
  try {
    
  $(function() {
    //Show pop up modal for each clicked card
      $('.team-card').click(function() {
        $(this).parent().find('.team-popup-modal').css('opacity', 1).fadeIn(300);
        $(".header-wrapper").css("position", "static");
        $("body").css("overflow", "auto");
      });
     
     //Pop up close
     $('.team-popup-modal, .team-popup-modal-inner').on('click', function(e) {
       if($(e.target) != $('.page-width') && !$(e.target).parents('.page-width team-popup-container').length) {
       		$('.team-popup-modal').css('opacity', 0).fadeOut(300);
          $(".header-wrapper").css("position", "sticky");
       }
     });
     
      $('.popup-close-button').click(function() {
          $('.team-popup-modal').css('opacity', 0).fadeOut(300);
          $(".header-wrapper").css("position", "sticky");
      });
      
      $(document).keydown(function (event) {
          if (event.keyCode == 27) {
              $('.team-popup-modal').css('opacity', 0).fadeOut(300);
              $(".header-wrapper").css("position", "sticky");
          }
      });
    });  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-info-tabs-section"] && !Shopify.designMode) return;
  try {
    
  $(document).ready(function () {
    $('.main-product-tab-btn').click(function () {
      const tabDataId = $(this).attr('data-id')
      
      $('.main-product-tab-btn').removeClass('active')
      $('.main-product-description-review__tab').removeClass('active')
      
      $(this).addClass('active')
      
      if (tabDataId == "description") {
        $('.main-product-description').addClass('active')        
      } else if (tabDataId == "review") {
        $('.main-product-review').addClass('active')
      }
      else if (tabDataId == "downloadable-element") {
        $('.main-product-downloadable-element').addClass('active')
      }
    })
  })

  } catch(e) { console.error(e); }
})();
})();
